<div class="d-flex flex-column">
  <div class="mg-l-30">
    <yo-menus-toolbar [gms]="gms"></yo-menus-toolbar>
  </div>
  <div >
    <yo-menus-planning2></yo-menus-planning2>
  </div>
</div>
